<template>
  <div id="sig-container" class="block full form-horizontal">
    <form @submit.prevent="guardarUsuario">
      <div class="loader" v-if="loading">
        <i class="fa fa-spinner fa-2x fa-spin text-info"></i>
      </div>
      <div class="widget">
        <div class="widget-content widget-content-mini themed-background-dark-default text-light">
          <span class="float-right text-muted">
            <button type="button" @click="$router.go(-1)" class="btn btn-xs btn-primary">
              Volver
            </button>
          </span>
          Gestión
        </div>
        <div class="widget-content border-bottom themed-background-muted text-center">
          <div class="container">
            <div class="row mt-2">
              <label for="" class="col-3 control-label text-right"><strong>Casa de Cobranza</strong></label>
              <div class="col-9">
                <select name="tipo" v-model="usuario.casa_cobranza_id" class="form-control"
                  :disabled="usuario.estado == 'inactivo'">
                  <option selected="">Seleccione ...</option>
                  <option v-for="casa in casasCobranza" :key="casa.id" :value="casa.id">
                    {{ casa.nombre }}
                  </option>
                </select>
                <span class="help-block" v-if="errors ? errors.casa_cobranza_id : false">{{ errors ?
                  errors.casa_cobranza_id[0] : "" }}</span>
              </div>
            </div>

            <div class="row mt-2">
              <label for="" class="col-3 control-label text-right"><strong>Tipo de Documento</strong></label>
              <div class="col-9">
                <select name="tipo" v-model="usuario.tipo_documento" class="form-control"
                  :disabled="usuario.estado == 'inactivo'">
                  <option value="">Seleccione ...</option>
                  <option value="CC">Cédula</option>
                  <option value="NIT">Nit</option>
                  <option value="TI">Tarjeta de Identidad</option>
                  <option value="NUIP">Nuip</option>
                  <option value="N/A">N/A</option>
                </select>
                <span class="help-block" v-if="errors ? errors.tipo_documento : false">{{ errors ?
                  errors.tipo_documento[0] : "" }}</span>
              </div>
            </div>

            <div class="row mt-2">
              <label for="" class="col-3 control-label text-right"><strong>Identificación</strong></label>
              <div class="col-9">
                <input type="text" v-model="usuario.identificacion" id="identificacion" class="form-control"
                  placeholder="Identificación" :disabled="usuario.estado == 'inactivo'" />
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{
              'has-error': errors ? errors['identificacion'] : false,
            }">
              <div class="col-9 offset-3">
                <span class="help-block" v-if="errors ? errors['identificacion'] : false">{{ errors ?
                  errors["identificacion"][0] : "" }}</span>
              </div>
            </div>

            <div class="row mt-2">
              <label for="" class="col-3 control-label text-right"><strong>Id Vicidial</strong></label>
              <div class="col-9">
                <input type="text" v-model="usuario.vicidial_id" id="vicidial_id" class="form-control"
                  placeholder="Id Vicidial" :disabled="usuario.estado == 'inactivo'" />
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{
              'has-error': errors ? errors['vicidial_id'] : false,
            }">
              <div class="col-9 offset-3">
                <span class="help-block" v-if="errors ? errors['vicidial_id'] : false">{{ errors ?
                  errors["vicidial_id"][0] : "" }}</span>
              </div>
            </div>

            <div class="row mt-2">
              <label for="" class="col-3 control-label text-right"><strong>Nombres</strong></label>
              <div class="col-9">
                <input type="text" v-model="usuario.nombres" id="nombres" class="form-control" placeholder="Nombres"
                  :disabled="usuario.estado == 'inactivo'" />
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{ 'has-error': errors ? errors['nombres'] : false }">
              <div class="col-9 offset-3">
                <span class="help-block" v-if="errors ? errors['nombres'] : false">{{ errors ? errors["nombres"][0] : ""
                }}</span>
              </div>
            </div>

            <div class="row mt-2">
              <label for="" class="col-3 control-label text-right"><strong>Apellidos</strong></label>
              <div class="col-9">
                <input type="text" v-model="usuario.apellidos" id="apellidos" class="form-control"
                  placeholder="Apellidos" :disabled="usuario.estado == 'inactivo'" />
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{
              'has-error': errors ? errors['apellidos'] : false,
            }">
              <div class="col-9 offset-3">
                <span class="help-block" v-if="errors ? errors['apellidos'] : false">{{ errors ? errors["apellidos"][0]
                  : "" }}</span>
              </div>
            </div>

            <div class="row mt-2">
              <label for="" class="col-3 control-label text-right"><strong>E-mail</strong></label>
              <div class="col-9">
                <input type="text" v-model="usuario.email" id="email" class="form-control" placeholder="E-mail"
                  :disabled="usuario.estado == 'inactivo'" />
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{ 'has-error': errors ? errors['email'] : false }">
              <div class="col-9 offset-3">
                <span class="help-block" v-if="errors ? errors['email'] : false">{{ errors ? errors["email"][0] : ""
                }}</span>
              </div>
            </div>

            <div class="row mt-2">
              <label for="" class="col-3 control-label text-right"><strong>Usuario</strong></label>
              <div class="col-9">
                <input type="text" v-model="usuario.username" id="username" class="form-control" placeholder="Usuario"
                  :disabled="usuario.estado == 'inactivo'" />
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{
              'has-error': errors ? errors['username'] : false,
            }">
              <div class="col-9 offset-3">
                <span class="help-block" v-if="errors ? errors['username'] : false">{{ errors ? errors["username"][0] :
                  "" }}</span>
              </div>
            </div>

            <div class="row mt-2" v-if="!usuario.id">
              <label for="" class="col-3 control-label text-right"><strong>Contraseña</strong></label>
              <div class="col-9">
                <input type="password" v-model="credentials.password" id="password" class="form-control"
                  placeholder="Contraseña" :disabled="usuario.estado == 'inactivo'" />
              </div>
            </div>
            <div class="row mt-2" v-bind:class="{
              'has-error': errors ? errors['password'] : false,
            }">
              <div class="col-9 offset-3">
                <span class="help-block" v-if="errors ? errors['password'] : false">{{ errors ? errors["password"][0] :
                  "" }}</span>
              </div>
            </div>

            <div class="row mt-2" v-if="!usuario.id">
              <label for="" class="col-3 control-label text-right"><strong>Confirmar Contraseña</strong></label>
              <div class="col-9">
                <input type="password" v-model="credentials.password_confirm" id="password_confirm" class="form-control"
                  placeholder="Confirmar Contraseña" :disabled="usuario.estado == 'inactivo'" />
              </div>
            </div>

            <div class="row mt-2" v-if="!usuario.id">
              <label class="col-3 control-label text-right"><strong>Nivel de permisos</strong></label>
              <div class="col-9">
                <select name="tipo" v-model="usuario.permisos" class="form-control"
                  :disabled="usuario.estado == 'inactivo'">
                  <option value="">Seleccione ...</option>
                  <option value="admin">Administrador</option>
                  <option value="asesor">Asesor</option>
                </select>
              </div>
            </div>

            <div class="row mt-2">
              <label class="col-3 control-label text-right"><strong>Descuento de capital</strong></label>

              <div class="custom-control custom-switch" style="padding-left: 50px">
                <input type="checkbox" class="custom-control-input" id="customSwitch1" v-model="usuario.condonacion"
                  :disabled="usuario.estado == 'inactivo'" />
                <label class="custom-control-label" for="customSwitch1"></label>
              </div>
            </div>

            <div class="row mt-2">
              <label class="col-3 control-label text-right"><strong>Ocultar información sensible</strong></label>

              <div class="custom-control custom-switch" style="padding-left: 50px">
                <input type="checkbox" class="custom-control-input" id="customSwitch3" v-model="usuario.ocultar_info" />
                <label class="custom-control-label" for="customSwitch3"></label>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12 text-center mt-3">
                <button type="submit" class="btn btn-sm btn-info mr-3"
                  :disabled="modal_inactivar || usuario.estado == 'inactivo'">
                  {{ usuario.id ? "Editar" : "Guardar" }}
                </button>
                <button type="button" @click="openModalInactivar()" class="btn btn-sm btn-warning mr-3"
                  :disabled="modal_inactivar" v-if="usuario.estado == 'activo'">
                  {{ "Inactivar" }}
                </button>
                <button type="button" @click="activarUsuario()" class="btn btn-sm btn-success mr-3"
                  :disabled="modal_inactivar" v-if="usuario.estado == 'inactivo'">
                  {{ "Activar" }}
                </button>
                <button type="button" @click="eliminarUsuario()" class="btn btn-sm btn-danger"
                  :disabled="modal_inactivar">
                  {{ "Eliminar" }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>

    <form v-if="modal_inactivar" @submit.prevent="inactivarUsuario()">
      <div class="row mt-2">
        <label class="col-3 control-label text-right"><strong>¿Reactivar automaticamente?</strong></label>

        <div class="custom-control custom-switch" style="padding-left: 50px">
          <input type="checkbox" class="custom-control-input" id="customSwitch2" v-model="reactivar_automatico"
            v-on:change="limpiarFechaReactivacion()" />
          <label class="custom-control-label" for="customSwitch2"></label>
        </div>
      </div>
      <div class="row mt-2">
        <label class="col-3 control-label text-right" style="font-size: 14px">
          <strong>Fecha reactivacion</strong>
        </label>
        <div class="col-6">
          <datepicker v-model="fecha_reactivacion" :format="'yyyy-MM-dd'" :input-class="'form-control'"
            :placeholder="'Fecha reactivación'" :language="es" :disabled="!reactivar_automatico"></datepicker>
        </div>
      </div>
      <!-- Contenedor para centrar los botones -->
      <div class="d-flex justify-content-center mt-3" style="padding-bottom: 225px">
        <btn type="button" class="btn btn-primary mx-2" @click="resetInactivar()" v-if="modal_inactivar">
          Cancelar
        </btn>
        <btn type="button" class="btn btn-primary mx-2" @click="inactivarUsuario()" v-if="modal_inactivar"
          :disabled="reactivar_automatico && fecha_reactivacion == ''">
          {{ "Guardar" }}
        </btn>
      </div>
    </form>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";

export default {
  name: "Crear-EditarUsuario",
  data: () => {
    return {
      usuario: {},
      credentials: {},
      errors: null,
      modal_inactivar: false,
      reactivar_automatico: true,
      fecha_reactivacion: "",
      es: es,
    };
  },
  computed: {
    ...mapGetters({ loading: "loading", casasCobranza: "casascobranza/casas" }),
  },
  components: {
    Datepicker,
  },
  methods: {
    guardarUsuario() {
      if (this.usuario.id) {
        this.editarUsuario();
        //this.updatePassword();
        return false;
      }

      this.$store
        .dispatch("store", {
          endpoint: "usuario",
          params: { ...this.usuario, ...this.credentials },
        })
        .then((response) => {
          this.$notify({
            title: "Usuario",
            type: "success",
            content: "La acción se completó con éxito",
          });
        })
        .catch((error) => {
          this.errors = error.data.errors;
          this.$notify({
            title: "Usuario",
            type: "warning",
            content: "Los datos dados no son válidos",
          });
        });
    },
    updatePassword() {
      if (this.credentials.password) {
        if (this.credentials.password == this.credentials.password_confirm) {
          this.$store
            .dispatch("store", {
              endpoint: "usuario/update-password",
              params: {
                id: this.usuario.id,
                new_password: this.credentials.password,
                password_confirm: this.credentials.password_confirm,
              },
            })
            .then((response) => {
              this.$notify({
                title: "Usuario",
                type: "success",
                content: "La acción se completó con éxito",
              });
            })
            .catch((error) => {
              this.errors = error.data.errors;
              this.$notify({
                title: "Usuario",
                type: "warning",
                content: "Los datos dados no son válidos",
              });
            });
        } else {
          this.$notify({
            title: "Usuario",
            type: "warning",
            content: "Las contraseñas no coinciden",
          });
        }
      }
    },
    editarUsuario() {
      this.$store
        .dispatch("edit", {
          endpoint: "usuario/" + this.usuario.id,
          params: this.usuario,
        })
        .then((response) => {
          this.$notify({
            title: "Usuario",
            type: "success",
            content: "La acción se completó con éxito",
          });
        })
        .catch((error) => {
          this.errors = error.data.errors;
          this.$notify({
            title: "Usuario",
            type: "warning",
            content: "Los datos dados no son válidos",
          });
        });

      this.updatePassword();
    },
    async eliminarUsuario() {
      try {
        if (
          confirm(
            "¿Está seguro que desea eliminar este usuario permanentemente?"
          )
        ) {
          this.$store
            .dispatch("remove", { endpoint: "usuario/" + this.usuario.id })
            .then((response) => {
              this.$notify({
                title: "Usuario",
                type: "success",
                content: "Se eliminó el usuario satisfactoriamente",
              });

              this.$router.push({ path: "/administrar/usuarios" });
            })
            .catch(() => {
              this.$notify({
                title: "¡Advertencia!",
                type: "warning",
                content: "Ha ocurrido un problema eliminando el usuario",
              });
            });
        }
      } catch (err) {
        this.$notify({
          title: "Usuario",
          type: "warning",
          content: "Ocurrio un error al intentar eliminar el usuario",
        });
      }
    },
    openModalInactivar() {
      this.modal_inactivar = true;
    },
    limpiarFechaReactivacion() {
      if (!this.reactivar_automatico) {
        this.fecha_reactivacion = "";
      }
    },
    resetInactivar() {
      this.modal_inactivar = false;
      this.fecha_reactivacion = "";
      this.reactivar_automatico = true;
    },
    inactivarUsuario() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");

      this.usuario.estado = "inactivo";
      this.usuario.fecha_inactivacion = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      if (this.fecha_reactivacion != "") {
        this.usuario.fecha_reactivacion =
          this.$moment(this.fecha_reactivacion).format("YYYY-MM-DD") +
          ` ${hours}:${minutes}:${seconds}`;
      } else {
        this.usuario.fecha_reactivacion = null;
      }

      if (
        this.esFechaMayor(this.usuario.fecha_reactivacion) ||
        !this.reactivar_automatico
      ) {
        this.$store
          .dispatch("edit", {
            endpoint: "usuario/" + this.usuario.id,
            params: this.usuario,
          })
          .then((response) => {
            this.$notify({
              title: "Usuario",
              type: "success",
              content: "La acción se completó con éxito",
            });
            if (this.$route.params.id) {
              this.$store
                .dispatch("show", {
                  endpoint: "usuario",
                  id: this.$route.params.id,
                })
                .then((response) => {
                  this.usuario = response;
                })
                .catch((error) => {
                  switch (error.status) {
                    case 404:
                      this.$notify({
                        title: "Usuario",
                        type: "warning",
                        content: "Casa de cobranza no encontrada",
                      });
                      break;
                    default:
                      this.$notify({
                        title: "Usuario",
                        type: "error",
                        content:
                          "Ha ocurrido un error, por favor comuníquese con un administrador del sistema",
                      });
                      break;
                  }
                });
            }
          })
          .catch((error) => {
            this.errors = error.data.errors;
            this.$notify({
              title: "Usuario",
              type: "warning",
              content: "Los datos dados no son válidos",
            });
          });

        this.resetInactivar();
      } else {
        this.$notify({
          title: "Usuario",
          type: "warning",
          content: "La fecha de reactivacion debe ser mayor a hoy",
        });
      }
    },
    esFechaMayor(fechaStr) {
      const fecha = new Date(fechaStr);
      const ahora = new Date();
      return fecha > ahora;
    },
    activarUsuario() {
      this.usuario.estado = "activo";
      this.usuario.fecha_inactivacion = null;
      this.usuario.fecha_reactivacion = null;

      this.$store
        .dispatch("edit", {
          endpoint: "usuario/" + this.usuario.id,
          params: this.usuario,
        })
        .then((response) => {
          this.$notify({
            title: "Usuario",
            type: "success",
            content: "La acción se completó con éxito",
          });
          if (this.$route.params.id) {
            this.$store
              .dispatch("show", {
                endpoint: "usuario",
                id: this.$route.params.id,
              })
              .then((response) => {
                this.usuario = response;
              })
              .catch((error) => {
                switch (error.status) {
                  case 404:
                    this.$notify({
                      title: "Usuario",
                      type: "warning",
                      content: "Casa de cobranza no encontrada",
                    });
                    break;
                  default:
                    this.$notify({
                      title: "Usuario",
                      type: "error",
                      content:
                        "Ha ocurrido un error, por favor comuníquese con un administrador del sistema",
                    });
                    break;
                }
              });
          }
        })
        .catch((error) => {
          this.errors = error.data.errors;
          this.$notify({
            title: "Usuario",
            type: "warning",
            content: "Los datos dados no son válidos",
          });
        });
    },
  },
  mounted() {
    if (!this.casasCobranza.length > 0) {
      this.$store.dispatch("casascobranza/fetch", {
        endpoint: "administracion/casascobranza",
        params: {
          paginar: "false",
        },
      });
    }

    if (this.$route.params.id) {
      this.$store
        .dispatch("show", { endpoint: "usuario", id: this.$route.params.id })
        .then((response) => {
          this.usuario = response;
        })
        .catch((error) => {
          switch (error.status) {
            case 404:
              this.$notify({
                title: "Usuario",
                type: "warning",
                content: "Casa de cobranza no encontrada",
              });
              break;
            default:
              this.$notify({
                title: "Usuario",
                type: "error",
                content:
                  "Ha ocurrido un error, por favor comuníquese con un administrador del sistema",
              });
              break;
          }
        });
    }
  },
};
</script>
